import { useEffect, useRef } from 'react';
import LoginHeader from '../../Header/LoginHeader';
import UserHeader from '../../Header/UserHeader';
import styles from './HomeContents.module.css';
import HotpleItem from '../Hotple/HotpleItem/HotpleItem';
import { BrowserView, MobileView } from 'react-device-detect';
import { forceCheck } from 'react-lazyload';
import HotpleAlbumItems from '../Hotple/HotpleAlbumItems/HotpleAlbumItems';


const HomeContents = ({setUserModalPage, setAuthModalPage, setInfoModalPage, setTutorialModalPage, activeMenu, setActiveMenu, setSelectedOption, selectedOption, notices, account, recommendHotples, myHotples, mapHotples, updateHotpleInfo, selectedHotple, setSelectedHotple, fcmToken, setModalProps, hotThreshold, mobileHotpleRefs, devicePosition, setAnlysisPageHotple}) => {
	const hotpleRefs = useRef({});
	const mobileContainerRef = useRef(null);

	const whenTopButtonClicked = () => {
		if (mobileContainerRef.current) {
			mobileContainerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
		  }
	};

	const whenAIHotpleRecommendButtonClicked = () => {
		alert(`데이트 때 뭐 먹지..?\n주말에 어디 가보지..?\n→ 고민중독인 당신을 위해! 🤯\n\n'AI 핫플 추천' 기능은 베타 테스트 종료 후 제공될 예정입니다.`);
	};

	const whenHotpleStoryButtonClicked = () => {
		alert(`인스타 스토리 올릴 뿐인데...\n돈도 벌 수 있다구? 💸\n\n'핫플 스토리 앱테크' 기능은 베타 테스트 종료 후 제공될 예정입니다.`);
	};

	const goReportPage = () => {
		window.open("https://forms.gle/e6as3uYGKJL6w7RPA", '_blank');
	};

	const goProposalPage = () => {
		window.open("https://forms.gle/4HeD37HgJay1PpZR8", '_blank');
	};

	useEffect(() => {
		if (selectedHotple && hotpleRefs.current[selectedHotple.hotple_id]) {
			hotpleRefs.current[selectedHotple.hotple_id].scrollIntoView({
				behavior: 'smooth',
				block: 'start'
			});
		}
		forceCheck();
	}, [selectedHotple]);

	useEffect(() => {
		forceCheck(); 
	}, [mapHotples]);

	const toggleSubCategoryOption = (category) => {
		if(selectedOption.sub_category == 'all' && category == 'all')
			return;
		
		if(selectedOption.sub_category == category)
			setSelectedOption((prev)=>({...prev, sub_category:'all'}));
		else
			setSelectedOption((prev)=>({...prev, sub_category:category}));
	}

  	return (
		<div className={styles.frame}>
			<BrowserView className={styles.contents}>
				{account.hotpleId == null ? <LoginHeader setAuthModalPage={setAuthModalPage} setTutorialModalPage={setTutorialModalPage} /> : <UserHeader setUserModalPage={setUserModalPage} setAuthModalPage={setAuthModalPage} setInfoModalPage={setInfoModalPage} setTutorialModalPage={setTutorialModalPage} activeMenu={activeMenu} setActiveMenu={setActiveMenu} setSelectedOption={setSelectedOption} account={account} myHotples={myHotples} fcmToken={fcmToken} setModalProps={setModalProps} />}
				<div className={styles.divider} />
				<div className={styles.maincontents} id='hotpleitems-container'>
					<div className={styles.innercontents}>
						<div className={styles.topcontents}>
							<div className={styles.funcButtonParent}>
								<div className={styles.funcButtons}>
									<div className={styles.recommendbutton2} onClick={()=>setInfoModalPage(61)}>
										<div className={styles.background2} />
										<img className={styles.iconinstagram} alt="" src="images/instagram.svg" />
										<div className={styles.text2}>
											<b className={styles.ai}>인스타 장소 AI 스크랩</b>
											<div className={styles.div1}>
												<p className={styles.p}>인스타하다 발견한 장소를 HOTPLE 지도에서 한 눈에!</p>
											</div>
										</div>
										<div className='buttonBadge'>NEW!</div>
									</div>
								</div>
								<div className={styles.funcButtons}>
									<div className={styles.recommendbutton} onClick={whenAIHotpleRecommendButtonClicked}>
										<div className={styles.background} />
										<img className={styles.iconmyLocation} alt="" src="images/my_location.svg" />
										<div className={styles.text}>
											<b className={styles.ai}>AI 핫플 추천</b>
											<div className={styles.div1}>
												<p className={styles.p}>뭐 먹지? 주말에 어디 가지?</p>
												<p className={styles.p}>고민중독인 당신을 위해!</p>
											</div>
										</div>
										<div className={styles.recommendbuttonChild} />
										<div className={styles.iconlockGroup}>
											<img className={styles.iconlock} alt="" src="images/lock.svg" />
											<div className={styles.div2}>업데이트 예정!</div>
										</div>
									</div>
									<div className={styles.recommendbutton} onClick={whenHotpleStoryButtonClicked}>
										<div className={styles.background1} />
										<img className={styles.iconfire} alt="" src="images/fire.svg" />
										<div className={styles.text}>
											<b className={styles.ai}>핫플 스토리</b>
											<div className={styles.div1}>
												<p className={styles.p}>인스타 스토리 올릴 뿐인데</p>
												<p className={styles.p}>돈도 벌 수 있다구?</p>
											</div>
										</div>
									<div className={styles.recommendbuttonChild} />
									<div className={styles.iconlockGroup}>
										<img className={styles.iconlock} alt="" src="images/lock.svg" />
										<div className={styles.div2}>업데이트 예정!</div>
									</div>
								</div>
							</div>
						</div>
						{/* <div className={styles.bannersFrame}>
							<img className={styles.bannerNotice} alt="" src="https://hotple.s3.ap-northeast-2.amazonaws.com/usage/banner.png" onClick={()=>setInfoModalPage(1)}/>
							{notices && notices.map(notice => (
								notice.banner_image_url && (
									notice.notice_url.includes('hotple.today') ? (
										<a 
											href={notice.notice_url} 
											key={notice.id}
											onClick={(e) => {
											e.preventDefault();
											window.location.href = notice.notice_url;
											}}
										>
											<img className={styles.bannerNotice} alt="" src={notice.banner_image_url} />
										</a>
									) : (
										<a 
											href={notice.notice_url} 
											target="_blank" 
											rel="noopener noreferrer" 
											key={notice.id}
										>
											<img className={styles.bannerNotice} alt="" src={notice.banner_image_url} />
										</a>
									)
								)
							))}
						</div> */}
						<div className={styles.bannersFrame}>
							{notices && notices.map(notice => (
								notice.banner_image_url && (
									notice.notice_url.includes('hotple.today') ? (
										<a 
											href={notice.notice_url} 
											key={notice.id}
											onClick={(e) => {
											e.preventDefault();
											window.location.href = notice.notice_url;
											}}
										>
											<img className={styles.bannerNotice} alt="" src={notice.banner_image_url} />
										</a>
									) : (
										<a 
											href={notice.notice_url} 
											target="_blank" 
											rel="noopener noreferrer" 
											key={notice.id}
										>
											<img className={styles.bannerNotice} alt="" src={notice.banner_image_url} />
										</a>
									)
								)
							))}
							{/* <div style={{position:'relative'}}>
								<img className={styles.bannerNotice} alt="" src="https://hotple.s3.ap-northeast-2.amazonaws.com/usage/region_instagram_follow_event_banner.png" onClick={()=>setInfoModalPage(31)}/>
								{account.hotpleId && <div className={styles.hotBadge}>+1,000HP</div>}
							</div> */}
							{notices.map(notice => (
								notice.banner_image_url && (
									<a href={notice.notice_url} target="_blank" rel="noopener noreferrer" key={notice.id}>
										<img className={styles.bannerNotice} alt="" src={notice.banner_image_url} />
									</a>
								)
							))}
							<div className={styles.formFrame}>
								<div className={styles.bugReport} onClick={goReportPage}>← 버그를 발견했어요!</div>
								<div className={styles.proposalReport} onClick={goProposalPage}>건의사항이 있어요! →</div>
							</div>
						</div>
					</div>
					<div className={styles.bottomcontents}>
						<div className={styles.title1}>
								<b className={styles.ai2}>내 주변 인스타 핫플 ❤️</b>
						</div>
						<div className={styles.hotpleitems}>
							{mapHotples.hotples && mapHotples.hotples.length > 0 ?
								mapHotples.hotples.map(hotple=>(
									<div
										key={hotple.hotple_id}
										ref={el => hotpleRefs.current[hotple.hotple_id] = el} // 각 HotpleItem에 대한 ref 할당
									>
										<HotpleItem key={hotple.hotple_id} hotple={hotple} activeMenu={activeMenu} updateHotpleInfo={updateHotpleInfo} setSelectedHotple={setSelectedHotple} isSelected={selectedHotple && hotple.hotple_id==selectedHotple.hotple_id} hotThreshold={hotThreshold} devicePosition={devicePosition} setAnlysisPageHotple={setAnlysisPageHotple}/>
									</div>
								))
								:
									<div className={styles.div9}>
										<img className={styles.markerstoryIcon} alt="" src="images/marker_position.svg" />
										<div className={styles.div10}>
											<p className={styles.p9}>해당 조건의 주변 핫플을 찾지 못했어요!</p>
											<p className={styles.p9}>지도를 옮겨 검색해볼까요?</p>
										</div>
									</div>
							}
						</div>
					</div>
				</div>
			</div>
		</BrowserView>

			<MobileView className={styles.contents}>
				{selectedHotple==null &&
				<>
					{account.hotpleId == null &&
						<LoginHeader setAuthModalPage={setAuthModalPage} setTutorialModalPage={setTutorialModalPage} />
					}
				</>
				}
				<div className={styles.maincontents1} ref={mobileContainerRef}>
					<div className={styles.innercontents}>
					{selectedHotple==null && 
					<>
						<div className={styles.topcontents}>
							<div className={styles.ai2}>새 소식 & 이벤트 📢</div>
							<div className={styles.bannersFrame}>
								{/* <img className={styles.bannerNotice} alt="" src="https://hotple.s3.ap-northeast-2.amazonaws.com/usage/banner.png" onClick={()=>setInfoModalPage(1)}/>
								{notices.map(notice => (
									notice.banner_image_url && (
										<a href={notice.notice_url} target="_blank" rel="noopener noreferrer" key={notice.id}>
											<img className={styles.bannerNotice} alt="" src={notice.banner_image_url} />
										</a>
									)
								))} */}
								{/* <div style={{position:'relative'}}>
									<img className={styles.bannerNotice} alt="" src="https://hotple.s3.ap-northeast-2.amazonaws.com/usage/region_instagram_follow_event_banner.png" onClick={()=>setInfoModalPage(31)}/>
									{account.hotpleId && <div className={styles.hotBadge}>+1,000HP</div>}
								</div> */}
								{notices.map(notice => (
									notice.banner_image_url && (
										<a href={notice.notice_url} target="_blank" rel="noopener noreferrer" key={notice.id}>
											<img className={styles.bannerNotice} alt="" src={notice.banner_image_url} />
										</a>
									)
								))}
								<div className={styles.formFrame}>
									<div className={styles.bugReport} onClick={goReportPage}>← 버그를 발견했어요!</div>
									<div className={styles.proposalReport} onClick={goProposalPage}>건의사항이 있어요! →</div>
								</div>
							</div>
						</div>
						<div className={styles.divider} />
					</>
					}
					<div className={styles.bottomcontents}>
					{selectedHotple==null && 
					<>
						<div className={styles.title1}>
								<div className={styles.ai2}>추천 인스타 핫플 ❤️</div>
								<div className={styles.sub}>실제 방문자 평가가 긍정적인 곳만 모아봤어요!</div>
						</div>
						<div className={styles.tagButtonFrame}>
							<div className={selectedOption.sub_category == 'all' ? styles.buttonActive : styles.button} key='all' onClick={()=>toggleSubCategoryOption('all')}>전체</div>
							{[...new Set(recommendHotples.hotples.map(hotple => hotple.sub_category1))].map((category, index) => (
								<div className={selectedOption.sub_category == category ? styles.buttonActive : styles.button} key={category} onClick={()=>toggleSubCategoryOption(category)}>#{category}</div>
							))}
						</div>
					</>
					}
						<div className={styles.hotpleitems}>
							{selectedHotple==null ?
								mapHotples.hotples && mapHotples.hotples.length > 0 ?
								<div
									className={styles.hotpleitem}
								>
									<HotpleAlbumItems
										mapHotples={mapHotples}
										activeMenu={activeMenu}
										setSelectedHotple={setSelectedHotple}
										hotThreshold={hotThreshold}
										mobileHotpleRefs={mobileHotpleRefs}
									/>
									<div style={{height:"58px"}}/>
								</div>
								:
									<div className={styles.div9}>
										<img className={styles.markerstoryIcon} alt="" src="images/marker_position.svg" />
										<div className={styles.div10}>
											<p className={styles.p9}>해당 조건의 주변 핫플을 찾지 못했어요!</p>
											<p className={styles.p9}>지도를 옮겨 검색해볼까요?</p>
										</div>
									</div>
							:
								<HotpleItem key={selectedHotple.hotple_id} hotple={mapHotples?.hotples?.find(hotple => hotple.hotple_id == selectedHotple?.hotple_id)} activeMenu={activeMenu} updateHotpleInfo={updateHotpleInfo} setSelectedHotple={setSelectedHotple} isSelected={true} hotThreshold={hotThreshold} devicePosition={devicePosition} setAnlysisPageHotple={setAnlysisPageHotple}/>
							}
						</div>
					</div>
					{selectedHotple === null && 
						<img className={styles.topButton} onClick={whenTopButtonClicked}  alt="" src="images/chevron_bottom.svg" />
					}
				</div>
			</div>
	</MobileView>
</div>
	);
};

export default HomeContents;
